import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
import { parse } from "query-string";
import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import { Content } from "../components/content";
import { DocumentActionList } from "../components/document-action-list";
import { DocumentMetadataDisplay } from "../components/document-metadata-display";
import { IAuthContextProps, withAuthContext } from "../components/with-auth-context";
import { ISnackbarContextProps, withSnackbar } from "../components/with-snackbar";
import { DebateNotesRequestFactory } from "../model/autogen/DebateNotesController";
import { DebateNotesModel } from "../model/autogen/DebateNotesModel";
import { DocumentPublishModel } from "../model/autogen/DocumentPublishModel";
import { UserLevel } from "../model/autogen/UserLevel";
import { NoteItemEditRoute } from "../route-paths";
import { DocumentDisplay } from "../components/display/common";
import { IRouteMatch } from "./editor-page";

export interface IDebateNotePageState {
    model: DebateNotesModel | undefined;
}

export type ItemPageProps = RouteComponentProps<IRouteMatch> & IAuthContextProps & ISnackbarContextProps;

class DebateNoteItemPageComponent extends React.Component<ItemPageProps, IDebateNotePageState> {
    constructor(props: ItemPageProps) {
        super(props);
        this.state = { model: undefined };
    }
    public async componentDidMount() {
        this.loadContent();
    }
    public componentDidUpdate(prevProps: ItemPageProps) {
        if (prevProps.match.params.id != this.props.match.params.id) {
            this.loadContent();
        }
    }
    private shouldIncludeDeleted(): boolean {
        const { includeDeleted } = parse(this.props.location.search);
        return this.props.user.level >= UserLevel.Editor && (!!includeDeleted == true);
    }
    private async loadContent() {
        const id = parseInt(this.props.match.params.id, 10)
        let model;
        try { 
            const result =  await this.props.callApi((fetcher) => DebateNotesRequestFactory.getById(fetcher, id, this.shouldIncludeDeleted()));;
            if (result) {
                model = result
            }
        } catch (e) {
            window.location.href = '/page-not-found';
        } 
        this.setState({ model });
    }
    private onPublishContent = async (e: any) => {
        if (this.state.model && confirm("Are you sure you want to publish this content?")) {
            this.props.showSnackbarMessage("Publishing content ...");
            const payload = {
                documentId: this.state.model.id
            } as DocumentPublishModel;
            const model = await this.props.callApi((fetcher) => DebateNotesRequestFactory.publish(fetcher, payload));
            this.props.showSnackbarMessage("Content published");
            window.location.href = '/data/unpublished';
            this.setState({ model });
        }
    }
    private onBeginDeleteFile = (id: number) => {
        this.props.showSnackbarMessage("Deleting file");
    }
    private onFileDeleted = (id: number) => {
        const { model } = this.state;
        if (model) {
            model.files = model.files.filter(f => f.id != id);
            this.props.showSnackbarMessage("File deleted");
            this.setState({ model });
        }
    }
    private onDelete = async (e: any) => {
        const { model } = this.state;
        if (model && confirm("Are you sure you want to delete this content?")) {
            this.props.showSnackbarMessage("Deleting content ...");
            try {
                const result = await this.props.callApi((fetcher) => DebateNotesRequestFactory.delete(fetcher, model.id));
                if (result) {
                    this.props.showSnackbarMessage("Content deleted");
                    this.props.history.goBack();
                }
            } catch (e) {
                this.props.showSnackbarMessage(`Failed to delete content: ${e}`);
            }
        }
    }
    public render() {
        const { model } = this.state;
        if (!model) {
            return <LinearProgress />;
        }

        return <Content>
            <DocumentMetadataDisplay model={model} />
            <DocumentDisplay item={model} onBeginDeleteFile={this.onBeginDeleteFile} onFileDeleted={this.onFileDeleted} />
            <DocumentActionList editRoute={NoteItemEditRoute(model.id)} model={model} user={this.props.user} onDelete={this.onDelete} onPublishContent={this.onPublishContent} />
        </Content>;
    }
}

export const DebateNoteItemPage = withSnackbar(withAuthContext(DebateNoteItemPageComponent) as any);


// WEBPACK FOOTER //
// ./src/pages/debate-note-item-page.tsx